import React from 'react';
import FuturePaidList from './FuturePaidList';
import OutstandingItems from './OutstandingItems';
import succeesImg from '../../../assets/img/success.svg'

const FooterSection = ({outstandingItems, futurePaidItems}) => {
    return (
        <div>
            { 
                outstandingItems.length ? 
                    <OutstandingItems
                        outstandingItems={outstandingItems}
                    />  
                    : null
            }
            { 
                futurePaidItems.length ?
                    <FuturePaidList
                        futurePaidItems={futurePaidItems}
                    /> 
                    : null
            }
        </div>
    );
};

export default FooterSection;